// SR status badge — DESIGN-SYSTEM.md §SR Status Colours.
import type { JSX } from "react";

const STATUS_STYLES: Record<string, string> = {
  new:         "bg-slate-100 text-slate-600",
  assigned:    "bg-blue-100 text-blue-700",
  scheduled:   "bg-indigo-100 text-indigo-700",
  in_progress: "bg-amber-100 text-amber-700",
  completed:   "bg-navy-100 text-navy-800",
  confirmed:   "bg-emerald-100 text-emerald-700",
  disputed:    "bg-red-100 text-red-700",
  cancelled:   "bg-slate-100 text-slate-400",
};

interface Props { status: string; }

export function SrStatusBadge({ status }: Props): JSX.Element {
  const cls = STATUS_STYLES[status] ?? "bg-slate-100 text-slate-600";
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${cls}`}>
      {status.replace("_", " ")}
    </span>
  );
}
